import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const List = styled.ul`
  padding: 0;
  li {
    list-style: none;
    display: inline;
    white-space: nowrap;
  }

  li:after {
    content: " • ";
    color: white;
  }

  li:last-child:after {
    content: none;
  }
`

export const MenuLink = styled(Link)`
  font-size: 14px;
  line-height: 100%;
  color: #FFFFFF;
  opacity: 1.00;
  text-decoration: none;
`

export const DeveloperText = styled.span`
  font-size: 14px;
  line-height: 100%;
  color: #FFFFFF;
  opacity: 1.00;
`



// WEBPACK FOOTER //
// src/components/FooterMenu/styles.js